import { Box, Grid, Paper } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { useEffect, useState } from 'react';
import { useKundenApi, useMessagesApi, useWelcomeApi } from '../ApiClient';
import GridContainer from '../components/container/GridContainer';
import MissingContactDataModal from '../components/dialog/MissingContactDataModal';
import { useStore } from '../store/context';
import DashAppointments from '../views/dashboard/DashAppointments';
import DashBookings from '../views/dashboard/DashBookings';
import DashContacts from '../views/dashboard/DashContacts';
import DashDocuments from '../views/dashboard/DashDocuments';
import DashMonitor from '../views/dashboard/DashMonitor';
import DashReports from '../views/dashboard/DashReports';
import DashReservations from '../views/dashboard/DashReservations';

const StartPage = observer((): JSX.Element => {
  const { welcomeStore, messageStore } = useStore();

  const welcomeApi = useWelcomeApi();
  const messageApi = useMessagesApi();
  const kundenApi = useKundenApi();

  const [showMissingContactModal, setShowMissingContactModal] = useState(false);

  useEffect(() => {
    async function checkContactData(customerId: number | null | undefined) {
      if (!customerId) return;
      try {
        const { data: contacts } = await kundenApi.getAllKundenTelefonDaten(
          customerId,
        );
        const hasContactData = contacts.some(
          c =>
            (c.email && c.email.trim() !== '') ||
            (c.telnr && c.telnr.trim() !== ''),
        );
        if (!hasContactData) {
          setShowMissingContactModal(true);
        }
      } catch (error) {
        console.log(error);
      }
    }

    async function fetchMessages() {
      if (welcomeStore.currentEstate) {
        try {
          const { data } = await messageApi.getAllCustomerMessages(
            welcomeStore.currentEstate.customerId,
          );
          messageStore.setMessages(data);
        } catch (error) {
          console.log(error);
        }
      }
    }

    async function fetchWelcomeData() {
      try {
        const { data } = await welcomeApi.getWelcomeData(
          welcomeStore.currentEstateId,
        );
        welcomeStore.setWelcomeData(data);
        fetchMessages();
        checkContactData(data.userData?.customerId);
      } catch (error) {
        // TODO: add error handling
        console.log(error);
      }
    }

    if (!welcomeStore.getWelcomeData()) fetchWelcomeData();
  }, [welcomeApi]);

  const { currentEstate } = welcomeStore;

  return (
    <Box marginLeft={1} marginRight={1}>
      <GridContainer>
        <Grid container spacing={2}>
          {currentEstate && (
            <>
              <Grid item xs={12} md={12}>
                <Box m={1} width={1}>
                  {currentEstate?.customerId && (
                    <DashMonitor
                      isMainDashboard
                      currentEstate={currentEstate}
                    />
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} md={12}>
                <Paper elevation={0}>
                  <DashDocuments />
                </Paper>
              </Grid>
              <Grid item xs={12} md={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={3}>
                    <DashContacts />
                    {process.env.REACT_APP_CLIENT?.includes('wbg') && (
                      <DashAppointments />
                    )}
                  </Grid>
                  <Grid item xs={12} md={9}>
                    <Box mb={2} width={1}>
                      {currentEstate?.customerId && (
                        <DashReports currentEstate={currentEstate} />
                      )}
                    </Box>
                    <Box mb={2} width={1}>
                      {currentEstate?.customerId && (
                        <DashBookings currentEstate={currentEstate} />
                      )}
                    </Box>
                    <Box mb={2} width={1}>
                      {currentEstate?.customerId && (
                        <DashReservations
                          customerId={currentEstate?.customerId}
                        />
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={12}>
                <Box m={1} />
              </Grid>
            </>
          )}
        </Grid>
      </GridContainer>
      <MissingContactDataModal
        open={showMissingContactModal}
        onClose={() => setShowMissingContactModal(false)}
      />
    </Box>
  );
});

export default StartPage;
